// extracted by mini-css-extract-plugin
module.exports = {"Document":"Document_Document__1bZ4j"};